import React from "react";

const Header = () => {
  return (
    <div
      style={{
        backgroundImage: "url(" + "images/body/banner.png" + ")",
      }}
      className="banner"
    >
      <div className="container mx-auto">
        <div className="row">
          <div className="col-lg-7 col-md-8 col-12">
            <h3 className="text-white">Smart Machines. Simple AI.</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta aut
              molestiae reiciendis quod adipisci quia ab deleniti recusandae
              maxime incidunt! Eveniet placeat dignissimos cum commodi
              distinctio beatae facilis molestiae repellat.
            </p>
            <div className="mt-5">
              <a href="/" className="btn--base bg-white text-dark">
                Start Today
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
